import { useState, useLayoutEffect } from "react";
import ResizeObserver from "resize-observer-polyfill";

export const useMeasureWithNode = (node) => {
  const [bounds, setBounds] = useState(null);

  useLayoutEffect(() => {
    if (!node) return;
    const updateBounds = () => {
      window.requestAnimationFrame(() => {
        if (!node) return;
        const rect = node.getBoundingClientRect();
        const { top, bottom, left, right, height, width } = rect;
        setBounds((prev) => {
          if (
            !prev ||
            prev.top !== top ||
            prev.bottom !== bottom ||
            prev.left !== left ||
            prev.right !== right
          ) {
            return { top, bottom, left, right, height, width };
          } else {
            return prev;
          }
        });
      });
    };
    const ro = new ResizeObserver(updateBounds);
    ro.observe(node);
    updateBounds();
    return () => ro.disconnect();
  }, [node]);

  return bounds;
};
